import React, {PureComponent, useEffect, useRef, useState} from 'react';
import { useAuthContext } from '../../contexts/AuthContext';
import { AgendaUserType, ComByUserIdQuery, ComByUserIdQueryVariables, GetAgendaCompanyQuery, GetAgendaCompanyQueryVariables, GetAgendaUserQuery, GetAgendaUserQueryVariables, UpdateAgendaUserMutation, UpdateAgendaUserMutationVariables, UsersByComIdQuery, UsersByComIdQueryVariables } from '../../graphql/API';
import { comByUserId, getAgendaCompany, getAgendaUser, updateAgendaUser, usersByComId } from './queries';
import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { Badge, Button, Col, Modal, Row, Spinner } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useParams } from "react-router-dom";
import Image from 'react-bootstrap/Image';
import Stack from 'react-bootstrap/Stack';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import CustomModal from '../../components/Modals/CustomModal';
import UserImage from '../../components/UserImage';
import Sidebar from '../services/Sidebar/Sidebar';
import { IoMedal } from 'react-icons/io5';
import { FaMedal } from 'react-icons/fa6';
import { BsFillTrophyFill } from 'react-icons/bs';
import { GiTrophy } from 'react-icons/gi';

// declare webkit & chrome for platform detection
declare global {
  interface Window {
    webkit?: {
      messageHandlers?: any;
    };
  }
}

const isMacOSApp = window.webkit?.messageHandlers?.callbackHandler;

// const getComId = async (email: string) => {
//   try {
//     // console.log("POST", email);
//     const response = await axios.post("/api/get_worker/comId", {
//       email: email,
//     });

//     // console.log("Get Work ComId:", response.data);
//     return response.data; // Retourne le client token
//   } catch (error) {
//     console.error("Error when getting worker comId :", error);
//     return null;
//   }
// };

// const getManager = async (email: string) => {
//   try {
//     // console.log("POST", email);
//     const response = await axios.post("/api/get_manager", {
//       email: email,
//     });

//     // console.log("Get Work ComId:", response.data);
//     return response.data; // Retourne le client token
//   } catch (error) {
//     console.error("Error when getting worker comId :", error);
//     return null;
//   }
// };

// const subscribeToFCMByBackend = (token: string, topic: string[]) => {
//   fetch("/api/FCM/subscribe-to-topic", {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json"
//     },
//     body: JSON.stringify({
//       token: token,
//       topic
//     })
//   });
// }

// const subscribeToTopics = async (comId: string, userId: string) => {
//   const FCMToken = localStorage.getItem("FCMToken");
//   if (FCMToken) {
//     const comPostsTopic = `${comId}_posts`;
//     const userTopic = userId;
    
//     try {
//       const alreadySubscribed = await localStorage.getItem('subscribedTopics');
//       const subscribed = alreadySubscribed ? JSON.parse(alreadySubscribed) : [];

//       const newSubscriptions = [];

//       if (!subscribed.includes(comPostsTopic) && !subscribed.includes(userTopic)) {
//         await subscribeToFCMByBackend(FCMToken, [comPostsTopic, userTopic]);
//         newSubscriptions.push(comPostsTopic);
//         newSubscriptions.push(userTopic);
//       }

//       if (!subscribed.includes(comPostsTopic)) {
//         await subscribeToFCMByBackend(FCMToken, [comPostsTopic]);
//         newSubscriptions.push(comPostsTopic);
//       }

//       if (!subscribed.includes(userTopic)) {
//         await subscribeToFCMByBackend(FCMToken, [userTopic]);
//         newSubscriptions.push(userTopic);
//       }

//       if (newSubscriptions.length > 0) {
//         const updated = Array.from(new Set([...subscribed, ...newSubscriptions]));
//         await localStorage.setItem('subscribedTopics', JSON.stringify(updated));
//         // console.log("✅ Topics souscrits :", updated);
//       }

//     } catch (err) {
//       console.error("❌ Erreur lors de la souscription aux topics :", err);
//     }
//   }
// };

const ProfileView = () => {
  // AUTH
  const {userId: AuthUserId} = useAuthContext();
  // I18N
  const { t } = useTranslation();
  // MODAL
  const [contentModal, setContentModal] = useState(null);
  const [linkModal, setLinkModal] = useState(null);
  const [showCustomModal, setShowCustomModal] = useState(false);
  const [showFooterModal, setFooterModal] = useState(true);
  // NAVIGATION
  const navigate = useNavigate();

  const {data: data, loading, error, refetch, fetchMore} = useQuery
    <GetAgendaUserQuery, GetAgendaUserQueryVariables>(getAgendaUser,
      {variables: {userId: AuthUserId}, fetchPolicy: "network-only",});

  const [getCompany, { data: dataCompany, loading: loadingCompany }] = useLazyQuery
    <GetAgendaCompanyQuery, GetAgendaCompanyQueryVariables>(getAgendaCompany);

  const [getMyCompany, { data: dataMyCompany, loading: loadingMyCompany }] = useLazyQuery<ComByUserIdQuery, ComByUserIdQueryVariables>(comByUserId, {
      variables: { userId: AuthUserId },
  });

  const [updateUser, { data: dataUser, loading: loadingUser }] = useMutation<UpdateAgendaUserMutation, UpdateAgendaUserMutationVariables>(updateAgendaUser);

  const user = data?.getAgendaUser;

  // useEffect(() => {
  //   refetch(); // Recharge les données à chaque montage du composant
  // }, []);
  useEffect(() => {
    document.title = t('title.dashboard');
  }, []);

  useEffect(() => {
    // get company added by you
    // getMyCompany();
    if (!user) return;
    if (!user.type) return;
    if (user) {
      // get company by comId from user
      if (user.comId) {
        getCompany({variables: { comId: user.comId }});
      }
    }
  //     } else {
  //       const getWorker = async () => {
  //         const workerComId = await getComId(user.email);
  //         console.log("workerComId", workerComId);
  //         if (workerComId.comId) {
  //           await updateUser({variables: {input: {userId: user.userId, comId: workerComId.comId}}})
  //           window.location.reload();
  //         } else {
  //           if (user.email && user.type === "EMPLOYEE") {
  //             navigate('/?missingCompanyLink');
  //           } else if (user.type === "MANAGER") {
  //             navigate(t('link.create_company'));
  //           }
  //         }
  //       }
  //       const callManager = async () => {
  //         let wait = false;
  //         if (user.email && user.type === "EMPLOYEE") {
  //           const resManager = await getManager(user.email);
  //           console.log('res', resManager);
  //           if (resManager?.type === "admin") {
  //             await updateUser({variables: {input: {userId: user.userId, type: AgendaUserType.MANAGER}}});
  //             wait = true;
  //             navigate(t('link.create_company'));
  //           }
  //           if (resManager?.type === "MANAGER") {
  //             await updateUser({variables: {input: {userId: user.userId, type: resManager.type}}});
  //             wait = true;
  //             navigate(t('link.create_company'));
  //           }
  //         }
  //         return wait;
  //       }
  //       (async () => {
  //         const wait = await callManager();
  //         if (!wait) {
  //           await getWorker();
  //         }
  //       })();
  //     }
  //     subscribeToTopics(user.comId, user.userId);
  //   }
  }, [user]);

  // const myCompany = dataMyCompany?.comByUserId?.items
  const company = dataCompany?.getAgendaCompany

  // useEffect(() => {
  //   // if (!user) return;
  //   // if (!user.type) return;
  //   if (user && myCompany) {
  //     if (!user.comId && myCompany.length > 0) {
  //       // const type = AgendaUserType.MANAGER // type: type
  //       updateUser({variables: {input: {userId: user.userId, comId: myCompany[0].comId}}})
  //     } 
  //   } 
  //   // else if (user && user.type === "MANAGER" && !user.comId) {
  //   //   navigate(t('link.create_company'));
  //   // }
  // }, [myCompany]);

  // useEffect(() => {
  //   if (user) {
  //     if (!user.comId && !company) {
  //       console.log('res');
  //       if (user.type === "EMPLOYEE") {
  //         const resManager = getManager(user.email);
  //         console.log('res', resManager);
  //         // updateUser({variables: {input: {userId: user.userId, comId: myCompany[0].comId}}})
  //       }
  //     }
  //   }
  // }, [company]);

  if (!user || !company) {
    return (
        <div className="spinnerContainer">
            {/* <Spinner animation="border" role="status" style={styles.spinner as React.CSSProperties}> */}
            <Spinner animation="border" role="status" className="spinner">
                <span className="visually-hidden">Loading...</span>
            </Spinner>   
        </div>
    )
  };

  // const deleteUser = async () => {
  //   const mobile_auth = "Schedulum--macOs-auth-key-jy53lopki$fekl";
  //   const res = await axios.post("/api/delete_account", {
  //     mobile_auth: mobile_auth,
  //     userId: user.userId,
  //     comId: user.comId,
  //     email: user.email
  //   });
  //   console.log("Delete User:", res.data);
  //   if (res.data.status === "success") {
  //     navigate('/?deletedAccount'); 
  //   } else {
  //     alert("Error when deleting your account");
  //   }
  // }

  const deleteUser = async () => {
    const domain = window.location.origin;
    var uri = `${domain}/api/delete_account`;
    const form_data = new FormData();
    const mobile_auth = "Schedulum-macOs-auth-key-jy53lopki$fekl";
    
    form_data.append("mobile_auth", mobile_auth);
    form_data.append("userId", user.userId);
    form_data.append("comId", user.comId);
    form_data.append("email", user.email);

    return fetch(uri, {
      method: 'POST',
      body: form_data,
      headers: {},
    })
    .then(res => res.json()).then(res => {
      if(res.status == "success"){
        navigate('/?deletedAccount');
        // return res;
      } else {
        console.log('error', res.message);
        alert("Error when deleting your account");
      }
    }).catch((err) => console.log("Error occured", err));
  }

  const doDeleteUser = async () => {
    setFooterModal(false);
      setContentModal(<>
      <Modal.Header closeButton>
          <Modal.Title>{t('post.areYouSure')}</Modal.Title>
          </Modal.Header>
      
          <Modal.Body>
              <p>{t('profile.deleteMessage')}</p></Modal.Body>
          <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowCustomModal(false)}>
              {t('shift.cancel')}
              </Button>
              <Button variant="danger" onClick={() => {deleteUser(); setShowCustomModal(false);}}>
              {t('shift.confirm')}
              </Button>
          </Modal.Footer>
      </>);
      setShowCustomModal(true);
  }

  // const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  // @ts-ignore
  const honorA = user?.honors?.items?.filter(h => h && h.type === "A"); 
  // @ts-ignore
  const honorB = user?.honors?.items?.filter(h => h && h.type === "B");
  // @ts-ignore
  const honorC = user?.honors?.items?.filter(h => h && h.type === "C");
  // @ts-ignore
  const honorD = user?.honors?.items?.filter(h => h && h.type === "D");
  
  return (
    <>
      <CustomModal
        show={showCustomModal}
        onHide={() => setShowCustomModal(false)}
        link={linkModal}
        children={contentModal}
        isFooter={showFooterModal}
      />
      <div className="d-flex">
        <Sidebar user={user} />
        <div className="users-container flex-grow-1 p-3">
          <Row className="g-3 bg-white p-3 rounded-4 shadow-sm hover:shadow-md mt-2">
            {/* Première colonne : Photo et heures */}
            <Col xs={12} md={6} className="d-flex flex-column align-items-center w-100 border-bottom mt-2 pb-2">
            <Row className="text-end w-100">
                <div className="p-2 mb-4 d-inline-block">
                  <span style={{position: 'relative'}} title={t('shift.roundMedal')}>
                    <IoMedal
                      name={"medal"}
                      style={{color: '#FFD700', marginRight: 10, cursor: 'help'}}
                      size={30}
                    />
                    <Badge pill bg="dark" style={
                      honorD.length < 10 ? {position: 'absolute', top:-15, right: 17, fontSize: 8} :
                      honorD.length < 100 ? {position: 'absolute', top:-15, right: 15, fontSize: 8} :
                      {position: 'absolute', top:-15, right: 11, fontSize: 8}} >
                      {honorD.length}
                    </Badge>
                  </span>
                  <span style={{position: 'relative'}} title={t('shift.starMedal')}>
                    <FaMedal
                      name={"medal"}
                      style={{color: '#FFD700', marginRight: 10, cursor: 'help'}}
                      size={30}
                    />
                    <Badge pill bg="dark" style={
                      honorC.length < 10 ? {position: 'absolute', top:-15, right: 17, fontSize: 8} :
                      honorC.length < 100 ? {position: 'absolute', top:-15, right: 15, fontSize: 8} :
                      {position: 'absolute', top:-15, right: 11, fontSize: 8}} >
                      {honorC.length}
                    </Badge>
                  </span>
                  <span style={{position: 'relative'}} title={t('shift.trophy2')}>
                    <BsFillTrophyFill
                      name={"medal"}
                      style={{color: '#FFD700', marginRight: 10, cursor: 'help'}}
                      size={30}
                    />
                    <Badge pill bg="dark" style={
                      honorB.length < 10 ? {position: 'absolute', top:-15, right: 17, fontSize: 8} :
                      honorB.length < 100 ? {position: 'absolute', top:-15, right: 15, fontSize: 8} :
                      {position: 'absolute', top:-15, right: 11, fontSize: 8}} >
                      {honorB.length}
                    </Badge>
                  </span>
                  <span style={{position: 'relative'}} title={t('shift.trophy')}>
                    <GiTrophy
                      name={"medal"}
                      style={{color: '#FFD700', marginRight: 10, cursor: 'help'}}
                      size={30}
                    />
                    <Badge pill bg="dark" style={
                      honorA.length < 10 ? {position: 'absolute', top:-15, right: 17, fontSize: 8} :
                      honorA.length < 100 ? {position: 'absolute', top:-15, right: 15, fontSize: 8} :
                      {position: 'absolute', top:-15, right: 11, fontSize: 8}} >
                      {honorA.length}
                    </Badge>
                  </span>
                </div>
              </Row>
              <Row>
                <Col className="d-flex flex-column">
                  <div className="p-2">
                    <UserImage user={user} customClass="userImage_lg shadow-sm hover:shadow-md" key={"worker_" + user.userId} />
                  </div>
                </Col>
                <Col className="d-flex flex-column">
                  <div className="p-2">
                    <p><span className="form-label">{t('user.username')}</span>: {user.username}</p>
                    <p><span className="form-label">{t('profile.firstname')}</span>: {user.firstName}</p>
                    <p><span className="form-label">{t('profile.lastname')}</span>: {user.lastName}</p>
                    <p><span className="form-label">{t('user.email')}</span>: {user.email}</p>

                    {user?.type === "MANAGER" ? (
                      company ? (
                        <>
                          <p>{company.name}</p>
                          {company.account_type !== "" ? (
                            <Link to={t('link.add_worker')}>{t('profile.add_worker')}</Link>
                          ) : (
                            <Link to={t('link.billing')}>{t('profile.choose_plan')}</Link>
                          )}
                        </>
                      ) : (
                        <Link to={t('')}>{t('profile.create_company')}</Link>
                      )
                    ) : (
                      <p>{company.name}</p>
                    )}
                  </div>
                  <div className="p-2">
                    <Button onClick={() => navigate(`/profile/${t('link.edit')}`)}>{t('profile.editProfile')}</Button>
                  </div>
                  { isMacOSApp && 
                    <div className="p-2">
                      <Button style={{backgroundColor: 'maroon', borderColor: 'red'}} onClick={doDeleteUser}>{t('profile.deleteAccount')}</Button>
                    </div>
                  }
                  {/* <div className="p-2">
                    <Link to={'/shifts'}>{t('profile.shifts')}</Link>
                  </div> */}
                </Col>
              </Row>
            </Col>
            <Col xs={12} md={6} className="d-flex flex-column align-items-center w-100">
          
              <Row className="p-2 d-flex flex-row justify-content-between">
                <Col className="d-flex flex-column text-start me-3">
                  <p>{t('user.hours')}: </p>
                  <p>{t('user.night')}: </p>
                  <p>{t('user.monday')}: </p>
                  <p>{t('user.tuesday')}: </p>
                  <p>{t('user.thursday')}: </p>
                  <p>{t('user.wednesday')}: </p>
                  <p>{t('user.friday')}: </p>
                  <p>{t('user.saturday')}: </p>
                  <p>{t('user.sunday')}: </p>
                  {user?.type === "MANAGER" && (
                    <p style={{whiteSpace: 'nowrap'}}>{t('user.isConfirmed')}: </p>
                  )}
                </Col>

                <Col className="d-flex flex-column text-end me-3">
                  <p>{user.hours ? user.hours : 0}</p>
                  <p>{user.night ? "🟢" : "🔴"}</p>
                  <p>{user.monday ? "🟢" : "🔴"}</p>
                  <p>{user.tuesday ? "🟢" : "🔴"}</p>
                  <p>{user.wednesday ? "🟢" : "🔴"}</p>
                  <p>{user.thursday ? "🟢" : "🔴"}</p>
                  <p>{user.friday ? "🟢" : "🔴"}</p>
                  <p>{user.saturday ? "🟢" : "🔴"}</p>
                  <p>{user.sunday ? "🟢" : "🔴"}</p>
                  {user?.type === "MANAGER" && (
                    <p>{user.isConfirmed ? "🟢" : "🔴"}</p>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default ProfileView;


